<template>
  <div
    :class="[
      {
        'bg-gray-100': readOnly,
        'bg-gray-200': disabled,
        'bg-white': !readOnly && !disabled,
      },
    ]"
    :style="error ? 'border: 1px solid #c20202 !important' : theme.input"
    class="flex w-full items-center rounded border border-solid border-gray-300"
  >
    <slot name="left" />
    <div v-if="icon" class="flex flex-shrink-0 items-center" :style="(theme.icon, 'padding-left: 1rem;')">
      <i :class="[`fa-${icon}`, iconSet]" class="text-md" />
    </div>
    <div class="flex-grow">
      <input
        ref="input"
        v-bind="$attrs"
        v-debounce="(val) => $emit('debounce', val)"
        :disabled="disabled || translating || readOnly"
        :readOnly="readOnly"
        class="h-10 w-full bg-transparent p-2 text-sm focus:outline-none"
        v-on="inputListeners"
      />
    </div>
    <slot name="right" />
    <button
      v-if="canTranslate"
      v-tippy
      :content="`Translate to ${$translator.toName(targetLanguage)}`"
      type="button"
      class="mr-2 text-primary-dark"
      :disabled="translating"
      @click="onTranslate"
    >
      <Icon v-if="translating" name="spinner-third fa-spin" />
      <Icon v-else name="language" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconSet: {
      type: String,
      default: 'fad',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    translate: {
      type: String,
      default: null,
    },
    targetLanguage: {
      type: String,
      default: null,
    },
    translateFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      translating: false,
    }
  },
  computed: {
    inputListeners() {
      const self = this
      return {
        ...this.$listeners,
        input(e) {
          self.$emit('input', e.target.value)
        },
      }
    },
    theme() {
      return {
        input: '',
        icon: 'color: black;',
      }
    },
    canTranslate() {
      return this.translate && this.targetLanguage && this.targetLanguage !== 'en'
    },
  },
  methods: {
    focus() {
      setTimeout(() => {
        this.$refs.input.focus()
      }, 200)
    },
    onTranslate() {
      if (this.canTranslate) {
        this.translating = true

        this.$translator
          .translate(this.translate, this.targetLanguage, this.translateFilters)
          .then((translatedText) => {
            this.$emit('input', translatedText)
            this.translating = false
          })
          .catch(() => {
            this.translating = false
          })
      }
    },
  },
}
</script>
